import { Outlet } from 'react-router';
import Navigation from '../Navigation';
import * as Styles from './styles';

const Layout = () => {
  return (
    <Styles.Wrapper>
      <Styles.Left>
        <Navigation />
      </Styles.Left>
      <Styles.Right>
        <Outlet />
      </Styles.Right>
    </Styles.Wrapper>
  );
};

export default Layout;
